import styled from "styled-components";
import { Card, Menu } from "semantic-ui-react";


export const ThumbnailStyledCard = styled(Card)`
.post-linkcaption,
.post-link,
textarea {
  color: ${({ textColor }) => textColor} !important;
  font-family: ${({ font }) => font} !important;
}

.post-link {
  font-size: 12px !important;
}
`;



export const PrimaryCard = styled(Card)`
  border-radius: ${({ radius }) => radius} !important;
  background-color: ${({ bgColor }) => bgColor} !important;
  border: ${({ border }) => border} !important;
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  max-width: 40rem !important;
  padding: 1.5rem !important;
  -webkit-box-shadow: ${({ shadow }) => shadow};
  box-shadow: ${({ shadow }) => shadow};
  -moz-box-shadow: ${({ shadow }) => shadow};
  margin: 0 !important;
  font-family: ${({ font }) => font} !important;

  .content {
    border: ${({ footerBorder }) => footerBorder} !important;
    background-color: ${({ bgColor }) => bgColor} !important;
  }

  .ui.card {
    border-radius: ${({ cardRadius }) => cardRadius} !important;
    box-shadow: none !important;
  }

  video {
    border-radius: ${({ cardRadius }) => cardRadius} !important;
  }

  .ui.card > .media-container > a > div,
  .ui.card > .media-container > a > div > img,
  .ui.card > .media-container > div.post-blurhash > canvas {
    border-radius: ${({ cardRadius }) => cardRadius} !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .ui.card > .media-container > a > div.no-footer,
  .ui.card > .media-container > a > div.no-footer > img,
  .ui.card > .media-container > div.no-footer,
  .ui.card > .media-container > div.no-footer > img,
  .ui.card > .media-container > div.post-blurhash.no-footer > canvas {
    border-radius: ${({ cardRadius }) => cardRadius} !important;
  }



  .ui.card > .media-container > .ui.embed.video {
    border-radius: ${({ cardRadius }) => cardRadius} !important;
  }

  .ui.card > div.content,
  .ui.cards > .card > div.content {
    border-radius: ${({ cardRadius }) => cardRadius} !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }

  .post-text,
  .postcard-tags {
    font-family: ${({ font }) => font} !important;

    .editable-textarea {
      font-family: ${({ font }) => font} !important;
    }
  }

  span {
    font-family: ${({ font }) => font} !important;
  }

  textarea {
    color: ${({ textColor }) => textColor} !important;
    font-family: ${({ font }) => font} !important;
  }

  p {
    width: 100%;
    margin: 0;
  }
`;

export const AppDiv = styled.div`
  color: ${({ color }) => color} !important;
  font-family: ${({ font }) => font} !important;

  .post-footer a,
  .post-footer p {
    color: ${({ color }) => color} !important;
    font-family: ${({ font }) => font} !important;
  }

  .category-carousel p,
  .category-carousel span {
    font-family: ${({ font }) => font} !important;
  }

  .ui.dropdown .item .text {
    font-family: ${({ font }) => font} !important;
  }
`;

export const HomeDiv = styled.div`
  font-family: ${({ font }) => font} !important;

  .home-container-introduction h1,
  .home-container-question h3,
  .social-desktop-button-text,
  .createdBy,
  .terms {
    font-family: ${({ font }) => font} !important;
  }

  .social-desktop-button {
    border-radius: ${({ radius }) => radius} !important;
  }
`;

export const ButtonContainer = styled.div`
  .ui.button {
    color: white;
    text-decoration: none;
    font-size: 1.05rem !important;
    border-radius: ${({ radius }) => radius} !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: ${({ font }) => font} !important;
    line-height: 1.5rem !important;

    &:hover {
      cursor: pointer;
    }
  }

  .ui.button.combined {
    color: white;
    text-decoration: none;
    font-size: 1.05rem !important;
    border-radius: ${({ radius }) => radius} !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: ${({ font }) => font} !important;
    margin: 0 !important;
    line-height: 1.5rem !important;

    &:hover {
      cursor: pointer;
    }
  }

  .generic-secondary-btn {
    border-radius: ${({ radius }) => radius} !important;
  }

  .ui.dropdown {
    color: white;
    text-decoration: none;
    padding: 0.8rem 1.5rem;
    font-size: 1.15rem !important;
    border-radius: ${({ radius }) => radius} !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-left: 1px solid white;
    line-height: 1.5rem !important;
  }
`;

export const StyledMenu = styled(Menu)`
  background: ${({ background }) => background} !important;
  .item {
    background: ${({ background }) => background} !important;
  }
  .nav-btn {
    border-radius: ${({ radius }) => radius} !important;
  }
`;
